/*
 * @Author: wuhao
 * @Date: 2019-07-04 17:47:19
 * @LastEditors: lisf
 * @LastEditTime: 2021-05-21 11:15:33
 * @Description: 全局导航守卫
 */
import router from '../router'
// import api from '@/api'
import vuex from '../store'
import store from '@/utils/storage'
// import Vue from 'vue'
import $ from 'jquery'
import { isAndroid, isIos } from '@/utils'

// 获取个人信息
// async function getUserInfo() {
//   if (store.get('token')) {
//     let res = await api.getUserInfo()
//     vuex.commit('setUserInfo', res.result)
//     if (res.result) {
//       vuex.commit('setCompanyId', res.result.companyList ? res.result.companyList[0].uri : '')
//     }
//   }
// }

export default {
  install() {
    router.beforeEach(async (to, from, next) => {
      const token = to.query.token || store.get('token')
      vuex.commit('setLogin', token)
      vuex.commit('setIsMobile', false)
      // 埋点

      // 添加全局历史记录
      $('#app').animate(
        {
          scrollTop: 0
        },
        0
      )
      document.documentElement.scrollTop = 0
      if (vuex.state.firstEnter) {
        if (isAndroid() || isIos()) {
          vuex.commit('setIsMobile', true)
          if (to.name === 'index') {
            next('/wap/index')
            return
          }
        }
      }
      // 获取登陆者信息
      next()
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/routerIntercept.js